import { useCallback } from 'react';

import { useParentHelperContext } from 'applications/GSP/pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { useSnackbarContext } from 'applications/GSP/pages/ParentHelper/providers/SnackbarProvider/hooks';

import type { SyntheticEvent } from 'react';

export const useDiscardChatDeleting = () => {
  const { onClose } = useSnackbarContext();
  const { setDeletedChatId } = useParentHelperContext();

  return useCallback(
    (e: SyntheticEvent | Event) => {
      setDeletedChatId(null);
      onClose(e);
    },
    [onClose, setDeletedChatId],
  );
};
